import './Support.css'

export default function Support(props) { 

    return (
        <div>
            <h1>Support</h1>
        </div>
    )
}